import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { MenuApiService } from '../menu-api.service';
import {ConsumerTypesActions} from '@emm/menu/store/consumer-types/consumer-types.actions';

@Injectable({
    providedIn: 'root'
})
export class ConsumerTypesEffects {

    loadAll$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumerTypesActions.loadAll),
            switchMap( () =>
                this.api.getConsumerTypes().pipe(
                    map((consumerTypes) => ConsumerTypesActions.loadAllSuccess({ consumerTypes })),
                    catchError(({ error }) => of(ConsumerTypesActions.loadAllFailure({ error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private api: MenuApiService) {}
}
